// todoListSlice.js
// Здесь будет описание редьюсера todoListSlice

export default function todoListSlice(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}
